import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { v2 } from '@lendica/api';

export function CompanyBootstrap({ defaultSubpath }: { defaultSubpath: string }) {
    const navigate = useNavigate();

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const memberships = (await v2.listMemberships()) as Array<{
                    company: string;
                    slug?: string;
                }>;
                if (cancelled) return;
                // Use the first company as the default
                const first = memberships[0] || { company: 'demo', slug: 'demo' };
                const key = first.slug ?? first.company;
                navigate(`/c/${key}/${defaultSubpath}`, { replace: true });
            } catch {
                // noop: stay on current route if memberships fail
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [navigate, defaultSubpath]);

    return null;
}
